export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11564.42c279b2.jpg";